(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.Accounts.FIG",
                {
                    url: "/FIG",
                    component: "figAccounts",
                    data: {
                        pageTitle: "FIG Accounts"
                    },
                    onEnter: [
                        "$state", "figXref", "parentFigXrefs", function ($state, figXref, parentFigXrefs) {
                            if (!figXref && parentFigXrefs.length === 0)
                                $state.target("Home.401");
                        }
                    ]
                });
        }
    ]);

    app.component("figAccounts",
        {
            templateUrl: "/App/Accounts/FIGAccounts/fig-accounts.html",
            controller: figAccountsController
        });

    figAccountsController.$inject = ["$q", "$mdDialog", "caseApi", "clientApi", "insuranceAccountApi", "_", "xrefAccountApi", "$timeout", "$state", "searchApi", "statusTypes", "externalAccountApi"];
    function figAccountsController($q, $mdDialog, caseApi, clientApi, insuranceAccountApi, _, xrefAccountApi, $timeout, $state, searchApi, statusTypes, externalAccountApi) {
        var $ctrl = this;

        var errorAlert = $mdDialog.alert({
            focusOnOpen: false,
            title: "An error retrieving accounts occured.",
            textContent: "Please refresh the page and try again.",
            ariaLabel: "Error alert",
            ok: "Close",
            skipHide: true
        });

        ng.extend($ctrl,
            {
                committing: false,
                connecting: 0,
                accountClients: {},
                clientCases: {},
                caseAccounts: {},
                sortBy: { col: "Client", asc: true },
                ui: { loading: true },
                searchClients: searchClients,
                selectClient: selectClient,
                accountsForCase: accountsForCase,
                commitChanges: commitChanges,
                toggleSort: toggleSort
            });

        function searchClients(term) {
            return clientApi.searchClients(term).then(function (results) {
                ng.forEach(results,
                    function (row) {
                        row.Term = row.Person.FirstName + " " + row.Person.LastName;
                    });

                results.push({ Term: "Create " + term, Name: term, Type: "NewClient" });
                return results;
            });
        }

        function selectClient(searchClient, account, $event) {
            if (!!searchClient) {
                if (searchClient.Type === "NewClient") {
                    var firstSpaceIndex = searchClient.Name.indexOf(" ");
                    var lastSpaceIndex = searchClient.Name.lastIndexOf(" ");
                    var nameLength = searchClient.Name.length;

                    var client = {
                        Person: {
                            FirstName: searchClient.Name.substring(0,
                                firstSpaceIndex !== -1 ? firstSpaceIndex : nameLength),
                            MiddleName: lastSpaceIndex !== firstSpaceIndex
                                ? searchClient.Name.substring(firstSpaceIndex + 1, lastSpaceIndex)
                                : null,
                            LastName: searchClient.Name.substring(
                                lastSpaceIndex !== -1 ? lastSpaceIndex + 1 : nameLength,
                                nameLength)
                        }
                    };
                    account.searchText = "";

                    return openAddClient(client, account, $event).then(function (response) {
                        searchClient = response;
                        account.searchText = client.Person.FirstName + " " + client.Person.LastName;
                        return getClientCases(searchClient, account);
                    });
                } else {
                    return getClientCases(searchClient, account);
                }
            }
        }

        function openAddClient(client, account, $event) {
            var alert = $mdDialog.alert({
                focusOnOpen: false,
                templateUrl: "/App/Accounts/AddAccountClient/addaccountclient-template.html",
                controller: "addAccountClientController",
                controllerAs: "$ctrl",
                targetEvent: $event,
                clickOutsideToClose: true,
                locals: {
                    client: client
                }
            });

            return $mdDialog.show(alert).then(function (response) {
                return response;
            });
        }

        function getClientCases(client, account) {
            if (!client) return $q.when();

            account.NewClient = client;

            if (!client.Id || $ctrl.clientCases[client.Id]) return $q.when();

            $ctrl.clientCases[client.Id] = [];
            return caseApi.getClientCases(client.Id).then(function (response) {
                $ctrl.clientCases[client.Id].push.apply($ctrl.clientCases[client.Id], response);
            },
                function () {
                    $ctrl.clientCases[client.Id] = [];
                });
        }

        function accountsForCase(caseId) {
            if (!caseId || $ctrl.caseAccounts[caseId]) return $q.when();

            $ctrl.caseAccounts[caseId] = [];

            return insuranceAccountApi.getCaseInsuranceAccounts(caseId).then(function (accounts) {
                $ctrl.caseAccounts[caseId].push.apply($ctrl.caseAccounts[caseId], accounts);
            }, function () { $ctrl.caseAccounts[caseId] = []; });
        }

        function commitChanges(accounts) {
            if (!accounts || accounts.length === 0) return $q.when();

            accounts = _.filter(accounts, function (account) {
                return account.Checked && !account.AccountId;
            });

            if (accounts.length === 0) return $q.when();

            $ctrl.committing = true;

            function reduce(acc, prop) {
                var inner = acc[prop];

                if (acc.NewClient) inner.Client.Id = acc.NewClient.Id;
                if (acc.NewCase && acc.NewCase.Id) inner.CaseId = acc.NewCase.Id;
                if (acc.NewAccount && acc.NewAccount.Id) inner.AccountId = acc.NewAccount.Id;

                return inner;
            }

            var annuities = _.map(_.filter(accounts, function (account) { return !!account.Annuity; }), function (acc) {
                return reduce(acc, "Annuity");
            });

            var life = _.map(_.filter(accounts, function (account) { return !!account.Life; }), function (acc) {
                return reduce(acc, "Life");
            });

            var longTermCare = _.map(_.filter(accounts, function (account) { return !!account.LongTermCare; }), function (acc) {
                return reduce(acc, "LongTermCare");
            });

            var batchSize = 25;

            var annuityBatches = _.chunk(annuities, batchSize);
            var lifeBatches = _.chunk(life, batchSize);
            var longTermCareBatches = _.chunk(longTermCare, batchSize);

            var promises = [];

            function processResponse(response) {
                ng.forEach(response, function (account) {
                    var a = _.find(accounts, function (acc) {
                        return acc.ArcPolicyGuid === account.ArcPolicyGuid;
                    });

                    if (a) {
                        var inner = a.Annuity || a.LongTermCare || a.Life;

                        a.AccountId = inner.AccountId = account.AccountId;
                        inner.CaseId = account.CaseId;
                        inner.Client.Id = account.Client.Id;
                    }
                });
            }

            function makeRequest(promise, batch, funcName) {
                return promise.then(function () {
                    return $timeout(function () {
                        return xrefAccountApi[funcName](batch).then(processResponse);
                    }, 1000);
                });
            }

            promises.push(_.reduce(annuityBatches, function (promise, batch) {
                return makeRequest(promise, batch, "addAnnuities");
            }, $q.when()));

            promises.push(_.reduce(lifeBatches, function (promise, batch) {
                return makeRequest(promise, batch, "addLife");
            }, $q.when()));

            promises.push(_.reduce(longTermCareBatches, function (promise, batch) {
                return makeRequest(promise, batch, "addLongTermCare");
            }, $q.when()));

            return $q.all(promises).then(function () {
                $ctrl.committing = false;
                $ctrl.connecting = 0;
            });
        }
        function toggleSort(col) {
            if ($ctrl.sortBy.col === col)
                $ctrl.sortBy.asc = !$ctrl.sortBy.asc;
            else
                $ctrl.sortBy = { col: col, asc: true };

            return refreshList();
        }

        function refreshList() {
            $ctrl.figAccounts = _.sortBy($ctrl.figAccounts,
                function (account) {
                    switch ($ctrl.sortBy.col) {
                        case "Advisors":
                            return [account.Advisors];
                        case "Client":
                            var name = account.Client.FirstName + " " + account.Client.LastName;
                            return name.trim(); 
                        case "AccountNumber":
                        case "AccountType":
                        case "Custodian":
                        case "Model":
                        default:
                            return account[$ctrl.sortBy.col];
                    }
                });

            if (!$ctrl.sortBy.asc) $ctrl.figAccounts = $ctrl.figAccounts.reverse();
        }

        $ctrl.$onInit = () => {
            externalAccountApi.getFigAccounts().then(function (accounts) {
                $ctrl.figAccounts = ng.forEach(accounts, function (account) {
                    var inner = account.Annuity || account.Life || account.LongTermCare;

                    ng.extend(account,
                        {
                            Checked: !!account.AccountId,
                            Advisors: inner.Advisors.map(a => `${a.FirstName} ${a.LastName}`).join(", "),
                            Client: inner.Client,
                            Premium: inner.EstimatedAmount,
                            AccountName: inner.Title,
                            Submitted: inner.SubmittedDate,
                            Status: statusTypes.toLong(inner.CurrentStatus)
                        });

                    return account;
                });
                refreshList();

                $ctrl.ui.loading = false;
            }).catch(function (error) {
                $ctrl.ui.loading = false;
                $mdDialog.show(errorAlert);
            });
        }
    }

})(window.app, window.angular); //jshint ignore:line